import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthorizationHeader, http, imageBaseUrl } from '../../config/http';
import { IconCalendarTime, IconChevronLeft, IconChevronRight, IconListDetails, IconReload, IconSearch, IconTransferIn, IconX } from '@tabler/icons-react';

import Input from '../../components/Input';
import moment from 'moment';
import useCabang from '../features/useCabang';
import { DinamicTitle } from '../../utils/DinamicTitle';
import { DateRangePicker } from 'react-date-range';
import Layouts from '../../layouts/Layouts';
import useKarat from '../features/useKarat';

const GaleriBarang = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalModal, setTotalModal] = useState(0);
    const [totalModalFilter, setTotalModalFilter] = useState(0);
    const [jmlBarang, setJmlBarang] = useState(0);
    const [jmlBerat, setJmlBerat] = useState(0);
    const [page, setPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const navigate = useNavigate();
    const [selectedKategori, setSelectedKategori] = useState('');
    const [selectJenisKategori, setSelectJenisKategori] = useState('');
    const [kategori, setKategori] = useState([]);
    const [selectStatus, setSelectStatus] = useState('');
    const [bakiId, setBakiId] = useState('');
    const [filterBaki, setFilterBaki] = useState([]);
    const [selectCabang, setSelectCabang] = useState('');
    const { karatOption, karatOptionId, setKaratOptionId } = useKarat();
    const [berat, setBerat] = useState('');
    const { cabang } = useCabang();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewSrc, setPreviewSrc] = useState('');


    const [filterBerat, setFilterBerat] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);


    const awal = moment(startDate).format('DD-MM-YYYY');
    const akhir = moment(endDate).format('DD-MM-YYYY');
    const filterBeratBarang = () => {
        setBerat(filterBerat);
    };

    useEffect(() => {
        const numbersArray = [];
        for (let i = 1; i <= 20; i++) {
            numbersArray.push(i);
        }
        setFilterBaki(numbersArray);
    }, []);




    const [selectedItems, setSelectedItems] = useState([]);
    const [isCheckedAll, setIsCheckedAll] = useState(false);

    function reloadDate() {
        getItems();
    }
    async function getKategori() {
        await http
            .get('/kategori', {
                headers: { Authorization: getAuthorizationHeader() },
            })
            .then((res) => {
                setKategori(res.data);
            })
            .catch((err) => {
                if (err.response === 'undefined') {
                    return null;
                } else if (err.response.status === 401) {
                    navigate('/login');
                }
            });
    }
    useEffect(() => {
        getKategori();
    }, [navigate]);

    function prevPage() {
        setCurrentPage(currentPage - 1);
        setSelectedItems([]);
        setIsCheckedAll(false);
    }


    const [search, setSearch] = useState('');
    DinamicTitle('Galeri Barang')
    async function getItems() {
        setLoading(true);
        try {
            const res = await http.get(
                `/item?per_page=10&${search === '' ? `&page=${currentPage}` : `&kode=${search}`}${selectedKategori === '' ? `` : `&kategori=${selectedKategori}`}${selectJenisKategori === '' ? `` : `&jenis_kategori=${selectJenisKategori}`}${selectStatus === '' ? `` : `&status=${selectStatus}`}${selectCabang === '' ? `` : `&cabang=${selectCabang}`}${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`}${bakiId === '' ? '' : `&no_baki=${bakiId}`}${karatOptionId === '' ? '' : `&karat=${karatOptionId}`}${berat === '' ? '' : `&berat=${berat}`}`,
                {
                    headers: { Authorization: getAuthorizationHeader() },
                }
            );

            setItems(res.data.data.data);
            setTotalModal(res.data.total_modal);
            setTotalModalFilter(res.data.total_modal_filter);
            setJmlBarang(res.data.data.total);
            setPage(res.data.data.last_page);
            setJmlBerat(res.data.total_berat_page);
            setItemsPerPage(res.data.data.per_page);
            setCurrentPage(res.data.data.current_page);
        } catch (err) {
            if (err.response === undefined) {
                console.error('Network error:', err);
            } else if (err.response.status === 401) {
                navigate('/login');
            }
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getItems();
    }, [
        selectedKategori,
        bakiId,
        // isDelete,
        search.length >= 10 ? search : '',
        selectJenisKategori,
        // isEdit,
        currentPage,
        selectStatus,
        selectCabang,
        awal,
        akhir,
        // isSubmitItem,
        karatOptionId,
        berat,
    ]);
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    const handleKategoriChange = (event) => {
        setSelectedKategori(event.target.value);
        setSelectJenisKategori('');
    };
    function nextPage() {
        setCurrentPage(currentPage + 1);
        setSelectedItems([]);
        setIsCheckedAll(false);
    }
    const handleJenisKategoriChange = (event) => {
        setSelectJenisKategori(event.target.value);
    };
    const selectionRange = {
        startDate: startDate,
        endDate: endDate,
        key: 'selection',
    };
    function handleSelect(date) {
        setStartDate(date.selection.startDate);
        setEndDate(date.selection.endDate);
    }

    return (
        <Layouts
            // title={'Galeri Barang'}
            compFilter={
                <div className="flex items-center gap-1.5">
                    <div className="dropdown dropdown-bottom">
                        <div tabIndex={0} className="bg-amber-500 hover:bg-amber-600 text-white p-2 rounded-md cursor-pointer transition-colors shadow-sm">
                            <IconCalendarTime />
                        </div>
                        <div tabIndex={0} className="dropdown-content menu -right-52 p-2 shadow-lg bg-white dark:bg-slate-800 rounded-lg z-20">
                            <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
                        </div>
                    </div>
                    <button onClick={() => window.location.reload()} className="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 p-2 rounded-md cursor-pointer transition-colors shadow-sm">
                        <IconReload />
                    </button>
                    <Input
                        onChange={(e) => setSearch(e.target.value)}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                        autoComplete="off"
                        type="search"
                        name="search"
                        placeholder="Cari Kode Barang"
                    />
                </div>
            }
        >
            <div className="flex bg-white dark:bg-slate-900 items-center gap-3 mt-0.5">
                <div className="flex items-center gap-2 w-full scrollbar overflow-x-auto p-2">
                    <select
                        onChange={(e) => setSelectCabang(e.target.value)}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                    >
                        <option value="">Etalase</option>
                        {cabang.map((cb) => (
                            <option key={cb.id} value={cb.id}>
                                {cb.nama_cabang}
                            </option>
                        ))}
                    </select>

                    <select
                        value={selectedKategori}
                        onChange={handleKategoriChange}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                    >
                        <option value="">Kategori</option>
                        {kategori.map((kt) => (
                            <option key={kt.id} value={kt.id}>
                                {kt.nama_kategori}
                            </option>
                        ))}
                    </select>

                    {selectedKategori && (
                        <select
                            onChange={handleJenisKategoriChange}
                            value={selectJenisKategori}
                            className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                        >
                            <option value="">Jenis Kategori</option>
                            {kategori
                                .find((kt) => kt.id === parseInt(selectedKategori))
                                ?.jenis_kategori.map((jk) => (
                                    <option key={jk.id} value={jk.id}>
                                        {jk.nama_jenis}
                                    </option>
                                ))}
                        </select>
                    )}

                    <select
                        onChange={(e) => setSelectStatus(e.target.value)}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                    >
                        <option value="">Status</option>
                        <option value={1}>Tersedia</option>
                        <option value={0}>Tidak Tersedia</option>
                    </select>

                    <select
                        onChange={(e) => setBakiId(e.target.value)}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                    >
                        <option value="">Baki</option>
                        {filterBaki.map((ftb) => (
                            <option value={ftb} key={ftb}>
                                {ftb}
                            </option>
                        ))}
                    </select>

                    <select
                        onChange={(e) => setKaratOptionId(e.target.value)}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                    >
                        <option value="">Karat</option>
                        {karatOption.map((kto) => (
                            <option value={kto} key={kto}>
                                {kto}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            {loading ? (
                <div className="flex items-center justify-center py-10">
                    <div className="w-8 h-8 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
                    <span className="ml-3 text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data...</span>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 p-4 md:p-5 mb-20">
                    {items.map((item, index) => {
                        return (
                            <div key={index} className="relative group rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
                                    <img
                                        src={item?.gambar1 === null ? '' : `${imageBaseUrl}${item?.gambar1[0]?.asli}`}
                                        alt=""
                                        className="w-full h-80 object-cover cursor-pointer group-hover:scale-105 transition-transform duration-300 brightness-105 contrast-[1.12]"
                                        onClick={() => {
                                            if (item?.gambar1 !== null) {
                                                setPreviewSrc(`${imageBaseUrl}${item?.gambar1[0]?.asli}`);
                                                setPreviewOpen(true);
                                            }
                                        }}
                                    />

                                <span className="absolute top-3 left-3 rounded-md text-sm font-bold bg-amber-500/90 text-white px-2.5 py-1 shadow-sm backdrop-blur-sm">
                                    {item?.cabang?.nama_cabang}
                                </span>
                                <span className="absolute top-3 right-3 rounded-md text-sm font-bold bg-slate-900/70 text-white px-2.5 py-1 shadow-sm backdrop-blur-sm">
                                    {item?.karat} krt
                                </span>

                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#5C5C5C]/90 via-[#5C5C5C]/60 to-transparent pt-6 pb-2 px-4 flex flex-col gap-0.5 pointer-events-none">
                                    <span className="text-white text-lg lg:text-xl font-bold truncate leading-tight tracking-tight">{item?.kode_item} | {item?.jenis_kategori?.nama_jenis}</span>
                                    <span className="text-amber-400 text-lg lg:text-xl font-bold truncate leading-tight tracking-tight">{item?.berat} gr | Modal: Rp {numberWithCommas(item?.harga_modal === undefined ? '0' : item?.harga_modal)}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            <div className="bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 bottom-0 left-0 py-2.5 w-full absolute">
                <div className="flex justify-between">
                    <div className="lg:flex hidden items-center gap-4 mx-3 lg:mx-10">
                        <div className="flex items-center gap-1.5">
                            <span className="text-xs font-semibold uppercase text-slate-500 dark:text-slate-400">Modal:</span>
                            <span className="text-sm font-bold text-amber-600 dark:text-amber-400 whitespace-nowrap">
                                Rp {numberWithCommas(totalModal === totalModalFilter ? totalModal : totalModalFilter)}
                            </span>
                        </div>
                        <div className="w-px h-5 bg-slate-200 dark:bg-slate-700"></div>
                        <div className="flex items-center gap-1.5">
                            <span className="text-xs font-semibold uppercase text-slate-500 dark:text-slate-400">Barang:</span>
                            <span className="text-sm font-bold text-slate-700 dark:text-slate-200">{jmlBarang}</span>
                        </div>
                        <div className="w-px h-5 bg-slate-200 dark:bg-slate-700"></div>
                        <div className="flex items-center gap-1.5">
                            <span className="text-xs font-semibold uppercase text-slate-500 dark:text-slate-400">Berat:</span>
                            <span className="text-sm font-bold text-slate-700 dark:text-slate-200">{jmlBerat} gr</span>
                        </div>
                    </div>
                    {/* mobile */}
                    <div className="dropdown dropdown-top lg:hidden mx-3 lg:mx-10">
                        <div
                            tabIndex={0}
                            className="bg-amber-500 hover:bg-amber-600 cursor-pointer p-2 text-white rounded-md shadow-sm transition-colors"
                        >
                            <IconListDetails />
                        </div>
                        <div tabIndex={0} className="dropdown-content menu p-3 shadow-lg bg-white dark:bg-slate-800 rounded-lg w-[320px] border border-slate-200 dark:border-slate-700">
                            <div className="space-y-3">
                                <div className="flex items-center justify-between pb-2 border-b border-slate-100 dark:border-slate-700">
                                    <span className="text-sm font-semibold uppercase text-slate-500 dark:text-slate-400">Modal</span>
                                    <span className="text-sm font-bold text-amber-600 dark:text-amber-400 whitespace-nowrap">
                                        Rp {numberWithCommas(totalModal === totalModalFilter ? totalModal : totalModalFilter)}
                                    </span>
                                </div>
                                <div className="flex items-center justify-between pb-2 border-b border-slate-100 dark:border-slate-700">
                                    <span className="text-sm font-semibold uppercase text-slate-500 dark:text-slate-400">Total Barang</span>
                                    <span className="text-sm font-bold text-slate-700 dark:text-slate-200">{jmlBarang} barang</span>
                                </div>
                                <div className="flex items-center justify-between">
                                    <span className="text-sm font-semibold uppercase text-slate-500 dark:text-slate-400">Total Berat</span>
                                    <span className="text-sm font-bold text-slate-700 dark:text-slate-200">{jmlBerat} gram</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="items-center flex justify-center space-y-2 text-sm sm:space-y-0 sm:space-x-3 mr-4 sm:flex">
                        <span className="block text-slate-600 dark:text-slate-400">
                            Halaman <span className="font-semibold text-amber-600 dark:text-amber-400">{currentPage}</span> dari <span className="font-semibold">{page}</span>
                        </span>
                        <div className="space-x-1">
                            <button
                                onClick={prevPage}
                                disabled={currentPage <= 1}
                                title="previous"
                                type="button"
                                className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-md shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 disabled:opacity-40 transition-colors"
                            >
                                <IconChevronLeft size={18} />
                            </button>
                            <button
                                onClick={nextPage}
                                disabled={currentPage >= page}
                                title="next"
                                type="button"
                                className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-md shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 disabled:opacity-40 transition-colors"
                            >
                                <IconChevronRight size={18} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {previewOpen && (
                <ImagePreviewOverlay src={previewSrc} onClose={() => setPreviewOpen(false)} />
            )}
        </Layouts>
    );
};

const ImagePreviewOverlay = ({ src, onClose }) => {
    const [scale, setScale] = useState(1);

    const zoomIn  = () => setScale((s) => Math.min(s + 0.5, 5));
    const zoomOut = () => setScale((s) => Math.max(s - 0.5, 0.5));
    const reset   = () => setScale(1);

    return (
        <div
            className="fixed inset-0 z-[9999] bg-black/95 flex flex-col"
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            {/* Image area */}
            <div className="flex-1 overflow-auto flex items-center justify-center p-4"
                onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
            >
                <img
                    src={src}
                    alt="preview"
                    style={{ transform: `scale(${scale})`, transformOrigin: 'center', transition: 'transform 0.2s ease' }}
                    className="max-w-none rounded-lg shadow-2xl"
                    draggable={false}
                />
            </div>

            {/* Bottom toolbar */}
            <div className="flex-shrink-0 flex items-center justify-center gap-4 py-4 bg-black/60 backdrop-blur-sm">
                <button onClick={zoomOut} className="w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 active:scale-95 text-white flex items-center justify-center transition-all" title="Zoom out">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /><line x1="8" y1="11" x2="14" y2="11" />
                    </svg>
                </button>
                <button onClick={reset} className="px-4 h-11 rounded-full bg-white/15 hover:bg-white/25 active:scale-95 text-white text-sm font-bold tracking-wide transition-all min-w-[64px]">
                    {Math.round(scale * 100)}%
                </button>
                <button onClick={zoomIn} className="w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 active:scale-95 text-white flex items-center justify-center transition-all" title="Zoom in">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /><line x1="11" y1="8" x2="11" y2="14" /><line x1="8" y1="11" x2="14" y2="11" />
                    </svg>
                </button>
                <div className="w-px h-6 bg-white/20 mx-1" />
                <button onClick={onClose} className="w-11 h-11 rounded-full bg-red-500/70 hover:bg-red-500 active:scale-95 text-white flex items-center justify-center transition-all" title="Tutup">
                    <IconX className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
};

export default GaleriBarang;
